import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { ProductAdsTable } from '../components/product_ads/ProductAdsTable'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { ProductAdPerformance } from '../types/product_ad_extended'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const ProductAds = observer(() => {
    const { profile } = useUser()
    const [store] = useState(new TableStore<ProductAdPerformance>(userStore, 'product ads'))
    const savedFiltersStore = useSavedFiltersStore()

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/product-ads', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <>
            <ProductAdsTable
                tableHooks={tableHooks}
                store={store}
                savedFiltersStore={savedFiltersStore}
            />
        </>
    )
})
